import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import TicketOfficesTemplate from './ticketOfficesTemplate';
import { ManagerContextProvider } from '../manager/components/context';
import PageError from '../error/pageError';

export default function TicketOfficesOrganization({ organization, path }) {
    return (
        <ManagerContextProvider>
            <Switch>
                <Route
                    exact
                    path={`${path}/`}
                    render={({ match, history }) => {
                        return <TicketOfficesTemplate organization={organization} match={match} />;
                    }}
                />
                {/* The organization file has been created for the routes (eg: create) that will be created in the future  */}

                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
            </Switch>
        </ManagerContextProvider>
    );
}

TicketOfficesOrganization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
